import { useContext } from 'react'

import { AnnotationQueryVariablesContext } from '../context'

/**
 * Reads `isPreview` from `AnnotationQueryVariablesContext`. Defaults to
 * `false` when the provider isn't mounted — that's the desired behaviour for
 * places that render annotation UI outside of a share preview (e.g. the
 * notifications inbox).
 */
export const useIsAnnotationPreview = (): boolean => {
  const context = useContext(AnnotationQueryVariablesContext)
  return context?.isPreview ?? false
}
